var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#242424;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-874.374 -1111.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M885.374,1119.515v-7.588a.413.413,0,0,0-.413-.412H874.786a.412.412,0,0,0-.412.412V1124.1a.411.411,0,0,0,.412.412h6.729a4,4,0,1,0,3.859-5Zm-10,4v-11h9v7.142a3.99,3.99,0,0,0-3,3.858Zm10,3a3,3,0,1,1,3-3A2.992,2.992,0,0,1,885.374,1126.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M880.771,1114.441h2.2a.5.5,0,0,0,0-1h-2.2a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M878.971,1113.441h-2.2a.5.5,0,0,0,0,1h2.2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M883.471,1116.714a.5.5,0,0,0-.5-.5h-2.2a.5.5,0,0,0,0,1h2.2A.5.5,0,0,0,883.471,1116.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M878.971,1116.214h-2.2a.5.5,0,0,0,0,1h2.2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M878.971,1118.987h-2.2a.5.5,0,0,0,0,1h2.2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M878.971,1121.761h-2.2a.5.5,0,0,0,0,1h2.2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M886.07,1122.46l-.7.7-.758.758-.4-.4-.2-.2L884,1123.3a.5.5,0,0,0-.7.719l.494.493.813.812,2.162-2.16a.5.5,0,0,0-.707-.707Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/termsOfUse.64a7c11b89ac29c1914487e3851d323e.svg";
export { ForwardRef as ReactComponent };